var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-item"},[_c('a',{attrs:{"href":_vm.info.OutLink,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.info.PicPath,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }